import { gql, type TypedDocumentNode } from "@apollo/client";

export type FacilityEmployment = {
  id: string;
  title: string;
  formattedTitle: string | null;
  jobClassification: string;
  startedOn: string | null;
  endedOn: string;
  person: {
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
    profilePhoto?: string;
    pgaId: string | null;
    latestProgram: {
      id: string;
      status: string;
      programType: {
        id: string;
        name: string;
      };
      band?: {
        terminatedReason?: string | null;
        terminatesOn?: string | null;
      } | null;
    } | null;
  };
};

export type FacilityFormerEmployeesQueryResponse = {
  facility: {
    id: string;
    employments: {
      nodes: FacilityEmployment[];
    };
  };
};

export interface FacilityFormerEmployeesQueryVariables {
  facilityId: string;
}

export const FACILITY_FORMER_EMPLOYEES_QUERY: TypedDocumentNode<
  FacilityFormerEmployeesQueryResponse,
  FacilityFormerEmployeesQueryVariables
> = gql`
  query FacilityFormerEmployees($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      employments(orderBy: ENDED_ON_DESC, active: false) {
        nodes {
          id
          title
          formattedTitle
          jobClassification
          startedOn
          endedOn
          person {
            id
            firstName
            lastName
            displayName
            profilePhoto
            pgaId
            latestProgram {
              id
              status
              programType {
                id
                name
              }
              band {
                terminatedReason
                terminatesOn
              }
            }
          }
        }
      }
    }
  }
`;
